export default __webpack_public_path__ + "static/media/planet11.381ac283.png";